import { Injectable } from '@angular/core';
import { ApiVersion } from '@core/constants';

import { BaseService } from '../base.service';

@Injectable({
  providedIn: 'root',
})
export class LoginService extends BaseService {
  readonly loginUrl = 'users/insecure/auth/access-token';
  readonly idpUrl = 'users/insecure/auth/idp-hint';

  login(email: string, password: string) {
    const body: any = {
      username: email,
      password: password,
      userType: 'CUSTOMER',
    };
    return this.post(this.loginUrl, body, {
      apiVersion: ApiVersion.V2,
      useAuthToken: false,
      useRecaptcha: true,
    });
  }

  idpHint(email: string) {
    const request = { username: email, userType: 'CUSTOMER' };
    return this.post<any>(this.idpUrl, request, {
      apiVersion: ApiVersion.V2,
      useAuthToken: false,
      useRecaptcha: true,
    });
  }
}
